import { render } from "./ExportSettingsTab.vue?vue&type=template&id=5b48eda6"
import script from "./ExportSettingsTab.vue?vue&type=script&lang=js"
export * from "./ExportSettingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__